/* @flow */

import React from 'react';
import Immutable from 'immutable';
import uuid from 'uuid';
import { Segment } from 'semantic-ui-react';
import GalleryImage from './GalleryImage';
import GalleryImageSelector from './GalleryImageSelector';
import { reorderElements, enforceElementsOrder } from 'utils/ordering';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const updateImages = images => updateFunction =>
  updateFunction(Immutable.Map(images.map(i => [i.order, i])).toList());

const mergeImages = (images, updated) =>
  updateImages(images)(map =>
    map.update(updated.order, i => ({
      ...i,
      ...updated,
    }))
  );

const removeImage = (images, toDelete) =>
  updateImages(images)(map => map.remove(toDelete.order));

const Edit = ({ content, onSerialize }: Props) => {
  const updateImages = items =>
    onSerialize({
      ...content,
      items,
    });

  const imageSelected = (resource: BucketResource) => {
    const images = content.items || [];
    const newImage = {
      id: uuid(),
      order: images.length,
      image: resource,
    };

    updateImages([...images, newImage]);
  };

  const imageUpdated = (updated: EditorialGalleryImage) => {
    const newImages = mergeImages(content.items, updated);
    updateImages(newImages.toArray());
  };

  const imageReordered = (image, order) => {
    const reordered = reorderElements(content.items, image, order);
    updateImages(reordered.toArray());
  };

  const imageDeleted = (image: EditorialGalleryImage) => {
    const newImages = enforceElementsOrder(removeImage(content.items, image));
    updateImages(newImages.toArray());
  };

  const resourceStrategy = content.layout.strategy;

  const renderContent = () => {
    if (content.items && content.items.length) {
      return (
        <div>
          <GalleryImageSelector
            onSelected={imageSelected}
            defaultResourceStrategy={resourceStrategy}
          />
          {content.items.map(i => (
            <GalleryImage
              key={i.order}
              defaultResourceStrategy={resourceStrategy}
              image={i}
              imageCount={content.items.length}
              onUpdate={imageUpdated}
              onReorder={imageReordered}
              onDelete={imageDeleted}
            />
          ))}
        </div>
      );
    }

    return (
      <GalleryImageSelector
        onSelected={imageSelected}
        defaultResourceStrategy={resourceStrategy}
      />
    );
  };

  return <Segment>{renderContent()}</Segment>;
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/gallery/Edit.js